import React from 'react'
import './likeButton.css'

function LikeButton() {

    const heartClick=()=>{
        var elem = document.getElementById("heart")
        elem.classList.toggle("is-active")
    }

  return (
    <div className="placement">
  <div id="heart" className="heart" onClick={heartClick}></div>
</div>
  )
}

export default LikeButton